import React, { useState, useRef } from 'react'
import { useAuth } from '../../../Global'
import { Auth } from 'aws-amplify'
import './ProfilePic.scss'

function ProfilePic({ value, setValue }) {
  const profilePictureInput = useRef(null)
  // const [value, setValue] = useState(null)

  function onSelectFile(event) {
    if (event.target.files?.[0]) {
      const fileUrl = URL.createObjectURL(event.target.files[0])
      setValue({ url: fileUrl, data: event.target.files[0] })
    }
  }

  function handleClickProfilePicture() {
    profilePictureInput.current.click()
  }

  return (
    <div className="App disableSelection">
      <input
        hidden
        ref={profilePictureInput}
        type="file"
        onChange={onSelectFile}
        accept="image/x-png,image/gif,image/jpeg"
      />
      <div className="disableSelection">
        {!value.data && !value.url ? (
          <div
            className="profile-picture-default disableSelection"
            alt="profile picture"
            onClick={handleClickProfilePicture}
          />
        ) : (
          <div
            className="profile-picture disableSelection"
            style={{
              backgroundImage: `url(${value.url})`,
            }}
            onClick={handleClickProfilePicture}
          >
            <div className="changePicture">Change Picture</div>
          </div>
        )}
      </div>
    </div>
  )
}

export default ProfilePic
